import { render, staticRenderFns } from "./TradeResults.vue?vue&type=template&id=4a73595f&scoped=true&"
import script from "./TradeResults.vue?vue&type=script&lang=js&"
export * from "./TradeResults.vue?vue&type=script&lang=js&"
import style0 from "./TradeResults.vue?vue&type=style&index=0&id=4a73595f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73595f",
  null
  
)

export default component.exports